import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { colors } from '../../styles';

export interface Props {
  label?: string;
}

export default class NavLabel extends React.Component<Props, any> {
  public render() {
    const { label } = this.props;

    return (
      <StyledLabel className="label">{label && <div>{label}</div>}</StyledLabel>
    );
  }
}

const StyledLabel = styled.div`
  display: block;
  background: ${colors.black};
  position: absolute;
  left: calc(100% + 0.5rem);
  border-radius: 3px;
  padding: 0.25rem 0.5rem;
  color: white;
  opacity: 0;
  pointer-events: none;
  z-index: 3;
  white-space: nowrap;
  transition: opacity 150ms linear;

  ::before {
    content: '';
    border-style: solid;
    border-width: 0.375rem 0.375rem 0.375rem 0;
    border-color: transparent ${colors.black} transparent transparent;
    position: absolute;
    left: -0.375rem;
    top: 0.4125rem;
  }
`;
